import axios from 'axios';
import config from '../config';
import { showError } from '../utils';

import { store } from '../store';
import { logEvent } from '../utils/logEvent';
import { mintAuthOtt } from './auth';

// Generic network call function to handle common API request patterns
function networkCall({ method, url, headers, params, data, ...extraOptions }) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

// Network call function for search-and-book APIs that use success flag
function searchBookNetworkCall({
  method,
  url,
  headers,
  params,
  data,
  ...extraOptions
}) {
  return axios({
    method,
    url,
    headers,
    params,
    data,
    ...extraOptions,
  })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.success) {
        return responseBody;
      } else {
        const error = new Error('Invalid response');
        error.data = responseBody;
        throw error;
      }
    })
    .catch((err) => {
      console.error(`Err [medicine-search-book/${url.split('/').pop()}]`, err);
      showError(err);
      throw err;
    });
}

export function PharmacyDashboard(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/newDashboard?version=1800009616`,
    headers,
  });
}

// export function getPharmacyPartners(lat, long, authToken) {
//   const headers = {
//     authorization: authToken,
//   };

//   return axios
//     .get(
//       `${config.apiBaseUrl}/medicine-delivery/v2/partners?lat=${lat}&lng=${long}`,
//       {
//         headers,
//       }
//     )
//     .then((resp) => {
//       const responseBody = resp.data;
//       if (responseBody.message === 'success') {
//         return responseBody;
//       } else {
//         const err = new Error('Invalid response');
//         err.data = responseBody;
//         showError(err);
//         throw err;
//       }
//     })
//     .catch((err) => {
//       showError(err);
//       throw err;
//     });
// }

export function uploadPrescriptionForMedDashboard(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/digitisation/upload-prescription`,
    headers,
  });
}

export function uploadPrescriptionForMed(
  requestData,
  onUploadProgress,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/add-multiple-files`,
    headers,
    data: requestData,
    onUploadProgress,
  });
}

export function uploadInvoiceForMed(requestData, onUploadProgress, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/medicine-delivery/v2/upload-invoice`,
    headers,
    data: requestData,
    onUploadProgress,
  });
}

export function removeFileFromPrescriptionMeds(
  fileId,
  prescriptionId,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/prescriptions/file/remove`,
    headers,
    data: { prescriptionId, fileId },
  });
}

// !UNUSED
export function getDigitsationStatusMeds(pharmacyPrescriptionId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.apiBaseUrl}/medicine-delivery/v2/digitisation/${pharmacyPrescriptionId}/status`,
    headers,
  });
}

export function submitDigitsationRequestMeds(
  pharmacyPrescriptionId,
  addressId,
  patientId,
  authToken,
  remark
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/submit-request`,
    headers,
    data: {
      pharmacyPrescriptionId,
      addressId,
      patientId,
      remark,
    },
  });
}

// !UNUSED
export function saveNewPatientMeds(patientDetails, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/medicine-delivery/v2/`,
    headers,
    data: patientDetails,
  });
}

// Labs-Service
export function editAddressMeds(addressDetails, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/labs-v2/address/edit`,
    headers,
    data: addressDetails,
  });
}

export function reimbursementRequestMeds(
  patientId,
  pharmacyPrescriptionId,
  invoiceId,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.apiBaseUrl}/medicine-delivery/v2/reimbursement-request`,
    headers,
    data: {
      patientId,
      pharmacyPrescriptionId,
      invoiceId,
    },
  });
}

export function fetchCartDetails(cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/cart/prescription/cartId/${cartId}`,
    headers,
  });
}

export function fetchCartAddress(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/cart/addresses`,
    headers,
  });
}

export function modifyCartQuantity(cartId, items, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/cart/prescription/cartId/${cartId}/modify`,
    headers,
    data: {
      items,
    },
  });
}

/**
 * Add address to exiting cart
 */
export function addAddressToCart(cartId, addressId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/cart/addresses/add`,
    headers,
    data: {
      cartId,
      addressId,
    },
  });
}

export function fetchPartnerList(cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/partners/list-partners?cartId=${cartId}`,
    headers,
  });
}

export function addSubstitute(cartId, drugId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/cart/${cartId}/addSubstitute`,
    headers,
    data: {
      drugId: drugId,
    },
  });
}

export function fetchPrebookingSummary(cartId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/cart/prescription/cartId/${cartId}`,
    headers,
  });
}

export function addNewAddress(body, authToken) {
  const headers = {
    authorization: authToken,
  };

  return axios
    .post(`${config.apiBaseUrl}/labs-v2/address`, body, {
      headers,
    })
    .then((resp) => {
      const responseBody = resp.data;
      if (responseBody.message === 'success') {
        return responseBody;
      } else {
        const err = new Error('Invalid response');
        err.data = responseBody;
        showError(err);
        throw err;
      }
    })
    .catch((err) => {
      showError(err);
      throw err;
    });
}

export function removeAddressCart(addressId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/cart/addresses/remove`,
    headers,
    data: { addressId },
  });
}

export function bookOrderForPharmacy(
  sponsorId,
  sponsorName,
  authToken,
  cartId,
  storeId,
  orderDeliveryType,
  amount = 0,
  history,
  isCareWallet,
  careWalletAmount
) {
  const headers = {
    authorization: authToken,
  };
  const redirectToPaymentGateway = async () => {
    // Not on phonepe in-app or some other error.
    // send to payment
    logEvent('Pharmacy Order Payment Started', {
      category: 'Pharmacy',
      screenName: 'Payement Screen',
      type: orderDeliveryType,
      sponsorId,
      sponsorName,
    });
    const queryParams = new URLSearchParams();
    if (cartId) {
      queryParams.append('cartId', cartId);
    }
    if (storeId) {
      queryParams.append('storeId', storeId);
    }
    if (orderDeliveryType) {
      queryParams.append(
        'deliveryType',
        storeId ? 'pick-up' : orderDeliveryType
      );
    }
    if (isCareWallet) {
      queryParams.append('careWalletAmount', careWalletAmount);
      queryParams.append('isCareWallet', isCareWallet);
      queryParams.append(
        'careWalletUserPayableAmount',
        Number(amount - careWalletAmount)
      );
    }
    queryParams.append('amount', amount.toString());
        const ott = await mintAuthOtt(authToken, 'payment');
    const authParam = ott ? `ott=${ott}` : `auth=${authToken.split(' ')[1]}`;
    window.location.assign(
      `${config.pharmaServer}/cart/submit?${queryParams.toString()}&${authParam}`
    );
  };
  if (amount === 0) {
    return redirectToPaymentGateway();
  }
  return window.PhonePe.PhonePe.build(window.PhonePe.Constants.Species.web)
    .then((sdk) => {
      // Call the API to fetch the data context
      return axios
        .get(`${config.pharmaServer}/cart/transact`, {
          params: {
            cartId,
            amount,
          },
          headers,
        })
        .then((res) => {
          console.log(res);
          const responseBody = res.data;
          if (responseBody.message === 'success') {
            const context = responseBody.data;
            if (sdk.isMethodSupported('openPaymentsPage')) {
              logEvent('Pharmacy Payment Completed', {
                category: 'Pharmacy',
                screenName: 'Payement Screen',
                type: orderDeliveryType,
                sponsorId,
                sponsorName,
              });

              history.replace('/processing-payment', {
                orderType: 'pharmacy',
                transactionId: responseBody.transactionId,
                successPage: `home/consult`,
                failurePage: `home/consult`,
                failureStateParameters: {
                  paymentFailed: true,
                },
              });
              return sdk.openPaymentsPage(
                'Visit',
                context,
                `${config.rootUrl}pharmacy`,
                'https://getvisitapp.com/img/png/Visit_logo.png',
                [
                  {
                    'Order For': 'Pharmacy',
                  },
                ]
              );
            }
            throw new Error('Phonepe method not supported');
          } else if (responseBody.message === 'failure') {
            logEvent('Pharmacy Order Payment Failed', {
              category: 'Pharmacy',
              screenName: 'Payement Screen',
              type: orderDeliveryType,
              sponsorId,
              sponsorName,
            });
            history.push('/home', {
              bookingFailed: true,
              errorMessage: responseBody.errorMessage,
            });
            return;
          } else {
            logEvent('Pharmacy Order Payment Failed', {
              category: 'Pharmacy',
              screenName: 'Payement Screen',
              type: orderDeliveryType,
              sponsorId,
              sponsorName,
            });
            throw new Error('Failed to get payment context');
          }
        });
    })
    .catch((err) => {
      console.log(err);
      try {
        const parsedError = JSON.parse(err);
        if (
          parsedError &&
          (parsedError.error_code === 'PAYMENT_DISMISS' ||
            parsedError.error_code === 'PAYMENT_TIMEOUT')
        ) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.replace('/home', {
            paymentFailed: true,
          });

          logEvent('Pharmacy Order Payment Failed', {
            category: 'Pharmacy',
            screenName: 'Payement Screen',
            type: orderDeliveryType,
            sponsorId,
            sponsorName,
          });

          return;
        }
        // in case of android, it could still be a null error.
        if (parsedError === 'null' || parsedError === null) {
          store.dispatch({
            type: 'SHOW_ERROR',
            payload: {
              errorTitle: 'Something went wrong',
              errorDesc: 'Your payment failed. Please retry your payment.',
            },
          });
          history.push('/home', {
            paymentFailed: true,
          });

          logEvent('Pharmacy Order Payment Failed', {
            category: 'Pharmacy',
            screenName: 'Payement Screen',
            type: orderDeliveryType,
            sponsorId,
            sponsorName,
          });

          return;
        }
      } catch (err) {
        console.log(err);
        //  Since we couldn't parse the error, it means it's not a string and hence not a phonepe dismiss/timeout error.
        // Not on phonepe in-app or some other error.
        // send to payment
        return redirectToPaymentGateway();
      }
    });
}

// export function bookOrderForPharmacy(cartId, authToken) {
//   const headers = {
//     authorization: authToken,
//   };

//   // return axios
//   //   .get(`${config.pharmaServer}/cart/submit?cartId=${cartId}`, {
//   //     headers,
//   //   })
//   //   .then((resp) => {
//   //     const responseBody = resp.data;
//   //     // const div = document.createElement('div');

//   //     // div.innerHTML = responseBody;
//   //     // console.log(div.querySelector('script')?.textContent);

//   //     if (responseBody.message === 'success') {
//   //       // console.log(responseBody);
//   //       return responseBody;
//   //     } else {
//   //       const err = new Error('Invalid response');
//   //       err.data = responseBody;
//   //       showError(err);
//   //       throw err;
//   //     }
//   //   })
//   //   .catch((err) => {
//   //     showError(err);
//   //     throw err;
//   //   });
// }

export function fetchPharmacyOrderDetails(transactionId, authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/cart/order/details/${transactionId}`,
    headers,
  });
}

export function selectPartnerStore(
  cartId,
  partnerId,
  partnerStoreId,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/partners/select-partner-store`,
    headers,
    data: {
      cartId,
      partnerId,
      partnerStoreId,
    },
  });
}

export function submitPrescriptionRequest(
  prescriptionId,
  addressId,
  authToken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/submit-prescription`,
    headers,
    data: {
      prescriptionId,
      addressId,
    },
  });
}

export const getPharmacyTimeline = (
  authToken,
  transactionId,
  digitisationId,
  cartId,
  orderId
) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/cart/order/detailsTrack/${
      digitisationId ?? transactionId
    }`,
    headers,
    params: {
      cartId,
      digitisationId,
      orderId,
    },
  });
};

export const getPharmacyPartnerCarts = (
  authToken,
  transactionId,
  digitisationId,
  cartId,
  isReOrderCart = 0
) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/carts`,
    headers,
    params: {
      digitisationRequestId: digitisationId,
      isReOrderCart,
    },
  });
};

export const getCancelOrders = (authToken) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/cart/order/cancelreasons`,
    headers,
  });
};

export const pharmacyCompletedOrder = (authToken, offset = 0) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/myOrders`,
    headers,
    data: {
      status: 'completed',
      limit: '10',
      offset,
    },
  });
};

export const pharmacyCancelledOrder = (authToken, offset = 0) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/myOrders`,
    headers,
    data: {
      status: 'cancelled',
      limit: '10',
      offset,
    },
  });
};

export const pharmacySubmitReview = (
  authToken,
  orderId,
  stars,
  comment,
  reason
) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/addReview`,
    headers,
    data: {
      orderId,
      stars,
      comment,
      reason,
    },
  });
};

export const pharmacyCancelOrder = async (
  authToken,
  OrderNo,
  Remarks,
  Comment
) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/cancelOrder`,
    headers,
    data: {
      OrderNo,
      Remarks,
      VendorName: 'VISITHEALTH',
      Comment,
    },
  });
};

export const cartModify = (authToken, body, cartId) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/cart/prescription/cartId/${cartId}/modify`,
    headers,
    data: body,
  });
};

// ######## PHARMACY SEARCH AND BOOK #############

export async function updateMedicineCartItems(authToken, itemId, quantity) {
  try {
    const headers = {
      authorization: authToken,
    };

    return searchBookNetworkCall({
      method: 'patch',
      url: `${config.pharmaServer}/search-and-book/cart/update`,
      headers,
      data: {
        cartItemId: itemId,
        quantity: quantity,
      },
    });
  } catch (err) {
    console.error('Err [medicine-search-book/updateMedicineCartId]', err);
    showError(err);
  }
}

export async function uploadPrescriptionSearchBook(
  requestData,
  onUploadProgress,
  authToken
) {
  try {
    const headers = {
      authorization: authToken,
    };

    return searchBookNetworkCall({
      method: 'post',
      url: `${config.pharmaServer}/digitisation/add-multiple-files`,
      headers,
      data: requestData,
      onUploadProgress,
    });
  } catch (err) {
    console.error(
      'Err [medicine-search-book/uploadPrescriptionSearchBook]',
      err
    );
    showError(err);
  }
}

export async function fetchPrescriptionSearchBook(authToken) {
  try {
    const headers = {
      authorization: authToken,
    };

    return searchBookNetworkCall({
      method: 'post',
      url: `${config.pharmaServer}/digitisation/upload-prescription`,
      data: {
        headers,
      },
    });
  } catch (err) {
    console.error(
      'Err [medicine-search-book/fetchPrescriptionSearchBook]',
      err
    );
    showError(err);
  }
}

export async function removeFileFromPrescriptionSearchBook(
  fileId,
  prescriptionId,
  authToken
) {
  try {
    const headers = {
      authorization: authToken,
    };

    return searchBookNetworkCall({
      method: 'post',
      url: `${config.pharmaServer}/digitisation/prescriptions/file/remove`,
      headers,
      data: { prescriptionId, fileId },
    });
  } catch (err) {
    console.error(
      'Err [medicine-search-book/removeFileFromPrescriptionSearchBook]',
      err
    );
    showError(err);
  }
}

export async function getTrackOrderDetails(authToken, orderId) {
  try {
    const headers = {
      authorization: authToken,
    };

    return searchBookNetworkCall({
      method: 'get',
      url: `${config.pharmaServer}/search-and-book/order/track`,
      headers,
      params: {
        orderId,
      },
    });
  } catch (err) {
    console.error('Err [medicine-search-book/getTrackOrderDetails]', err);
    showError(err);
  }
}

export async function getServiceableList(authToken, lat, long, pincode) {
  try {
    const headers = {
      authorization: authToken,
    };

    return searchBookNetworkCall({
      method: 'get',
      url: `${config.pharmaServer}/search-and-book/partner/location/availability/list`,
      headers,
      params: {
        latitude: lat,
        longitude: long,
        pincode,
      },
    });
  } catch (err) {
    console.error('Err [medicine-search-book/getServiceableList]', err);
    showError(err);
  }
}

export async function cancelSearchBookOrder(
  authToken,
  orderId,
  code,
  description
) {
  const headers = {
    authorization: authToken,
  };

  return searchBookNetworkCall({
    method: 'post',
    url: `${config.pharmaServer}/search-and-book/order/cancel`,
    headers,
    data: {
      orderId,
      reason: {
        code: code,
        description,
      },
    },
  });
}

export async function getMedicineSuggestion(
  authToken,
  query,
  lat,
  lng,
  pincode
) {
  const headers = {
    authorization: authToken,
  };

  const params = {
    prefix: query,
    limit: 10,
  };

  if (lat && lng) {
    params.latitude = lat;
    params.longitude = lng;
  }

  if (pincode) {
    params.pincode = pincode;
  }

  return searchBookNetworkCall({
    method: 'get',
    url: `${config.pharmaServer}/search-and-book/drug/prefix/name/list`,
    headers,
    params,
  });
}

export async function getMedicineCategory(authToken) {
  const headers = {
    authorization: authToken,
  };

  return searchBookNetworkCall({
    method: 'get',
    url: `${config.pharmaServer}/search-and-book/drug/category/list`,
    headers,
  });
}
export async function getTopMedicineProducts(authToken, lat, long, pincode) {
  const headers = {
    authorization: authToken,
  };

  return searchBookNetworkCall({
    method: 'get',
    url: `${config.pharmaServer}/search-and-book/drug/popular/detailed/list`,
    headers,
    params: {
      latitude: lat,
      longitude: long,
      pincode: pincode,
      limit: 20,
    },
  });
}
export async function getMedicineCategoryItems(
  authToken,
  cat,
  page,
  lat,
  long,
  pincode
) {
  const headers = {
    authorization: authToken,
  };

  return searchBookNetworkCall({
    method: 'get',
    url: `${config.pharmaServer}/search-and-book/drug/category/detailed/list`,
    headers,
    params: {
      category: cat,
      page: page,
      latitude: lat,
      longitude: long,
      pincode: pincode,
      limit: 10,
    },
  });
}
export async function getMedicineSearchList(
  authToken,
  query,
  lat,
  long,
  pincode
) {
  const headers = {
    authorization: authToken,
  };

  const retainSpacesInQuery = encodeURIComponent(query).replaceAll(/%20/g, ' ');

  const params = {
    drugName: retainSpacesInQuery,
    limit: 10,
  };

  if (lat && long && pincode) {
    params.latitude = lat;
    params.longitude = long;
    params.pincode = pincode;
  }

  return searchBookNetworkCall({
    method: 'get',
    url: `${config.pharmaServer}/search-and-book/drug/name/detailed/list`,
    headers,
    params,
  });
}
export async function addMedicineCartItems(
  authToken,
  cartId,
  drugId,
  quantity
) {
  const headers = {
    authorization: authToken,
  };

  const body = {
    cartItem: {
      dimDrugId: drugId,
      quantity: quantity,
    },
  };

  if (cartId) {
    body.cartId = cartId;
  }

  return searchBookNetworkCall({
    method: 'post',
    url: `${config.pharmaServer}/search-and-book/cart/add`,
    headers,
    data: body,
  });
}

export async function getMedicineCartItemCount(authToken) {
  const headers = {
    authorization: authToken,
  };

  return searchBookNetworkCall({
    method: 'get',
    url: `${config.pharmaServer}/search-and-book/cart/id/item/count`,
    headers,
  });
}

export async function getMedicineCartDetails(
  authToken,
  cartId,
  lat,
  long,
  pincode
) {
  const headers = {
    authorization: authToken,
  };

  const locationInfo = store.getState().user.locationInfo;
  const {
    lat: stateLat,
    long: stateLong,
    pincode: statePincode,
  } = locationInfo;

  const params = {
    cartId: cartId,
  };

  if (stateLat && stateLong && statePincode) {
    params.latitude = stateLat;
    params.longitude = stateLong;
    params.pincode = statePincode;
  }

  return searchBookNetworkCall({
    method: 'get',
    url: `${config.pharmaServer}/search-and-book/cart/detail`,
    headers,
    params,
  });
}
export async function searchBookMedicinePlaceOrder(
  authToken,
  cartId,
  addressId,
  pharmacyPrescriptionId
) {
  const headers = {
    authorization: authToken,
  };

  return searchBookNetworkCall({
    method: 'post',
    url: `${config.pharmaServer}/search-and-book/order/place`,
    headers,
    data: {
      cartId,
      addressId,
      ...(pharmacyPrescriptionId && { pharmacyPrescriptionId }),
    },
  });
}

export function getPrescriptions(authToken, prescriptionType) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/selectPrescription`,
    headers,
    params: {
      prescriptionType,
    },
  });
}

export const teleConsultRXSubmitRequest = (authToken, data) => {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/teleconsultation-rx/submit-request`,
    headers,
    data,
  });
};

export function getAllDigitisationQueryHistoryMeds(
  authToken,
  digitisationId,
  actionTaken
) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/digitisation/get-query-history`,
    headers,
    params: {
      digitisationId,
      actionTaken,
    },
  });
}

export function getAllDocs(authToken) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'get',
    url: `${config.pharmaServer}/digitisation/upload-prescription`,
    headers,
  });
}

export function uploadMedsDocuments(authToken, data) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/add-multiple-files`,
    headers,
    data,
  });
}

export function removeDocumentMeds(authToken, data) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/prescriptions/file/remove`,
    headers,
    data,
  });
}

export function submitDoc(authToken, data) {
  const headers = {
    authorization: authToken,
  };

  return networkCall({
    method: 'post',
    url: `${config.pharmaServer}/digitisation/submit-request`,
    headers,
    data,
  });
}
